import { render, staticRenderFns } from "./crudReportSeller.vue?vue&type=template&id=e2b494d6&"
import script from "./crudReportSeller.vue?vue&type=script&lang=js&"
export * from "./crudReportSeller.vue?vue&type=script&lang=js&"
import style0 from "./crudReportSeller.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports